import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { EXECINCHARGE_INIT_LOADING, EXECINCHARGE_INIT_SUCCESS, EXECINCHARGE_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [EXECINCHARGE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [EXECINCHARGE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [EXECINCHARGE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async execInChargeManagement({ commit, rootState }) {
    const apiUrl = rootState.app.menu.execICManagement
    commit(EXECINCHARGE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(EXECINCHARGE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(EXECINCHARGE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
